import { MaintenanceNotification } from 'features/claims/types'

export function sortNotificationsByDate(notifications: MaintenanceNotification[]): MaintenanceNotification[] {
  return [...notifications].sort((a, b) => {
    const aStart = Date.parse(String(a.startOn))
    const bStart = Date.parse(String(b.startOn))

    // If one start date is invalid, push it to the end
    if (isNaN(aStart) && isNaN(bStart)) {
      return 0
    } else if (isNaN(aStart)) {
      return 1
    } else if (isNaN(bStart)) {
      return -1
    }

    // Compare start dates (descending)
    if (aStart !== bStart) {
      return bStart - aStart
    }

    // If start dates are equal, compare end dates (descending)
    const aEnd = Date.parse(String(a.endOn))
    const bEnd = Date.parse(String(b.endOn))

    if (isNaN(aEnd) && isNaN(bEnd)) {
      return 0
    } else if (isNaN(aEnd)) {
      return 1
    } else if (isNaN(bEnd)) {
      return -1
    }

    return bEnd - aEnd
  })
}

export function isNotificationActive(
  startOn: string | Date | undefined,
  endOn: string | Date | undefined,
  now: Date,
): boolean {
  if (!startOn || !endOn) return false

  const startDate = new Date(startOn)
  const endDate = new Date(endOn)

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
    console.warn(`[Maintenance] Invalid date range:`, { startOn, endOn })
    return false
  }

  return startDate <= now && now <= endDate
}
